module.exports = __webpack_public_path__ + "img/01d.0cd4dc18.png";